import { useRoutes } from 'react-router-dom';
import './App.scss';
import Footer from './shared/components/footer/footer';
import Header from './shared/components/header/header';
import { routes } from './routes/router';
import WhatsAppChatModel from './shared/components/whats-up/whats-up';

function App() {
  const pages = useRoutes(routes);
  return (
    <div className="App">
      
      <Header></Header>
      <main className='pages-group'>
        {pages}
      </main>
      <Footer></Footer>
   
  <WhatsAppChatModel />


    </div>
  );
}

export default App;
